import { Platform } from '@angular/cdk/platform';
import { Injectable } from '@angular/core';
import { SeverityLevel } from '@epicuro-next/models/platform/monitoring';
import { selectDisabledShareBrowserApi } from '@epicuro-next/platform/configuration';
import { LoggerService } from '@epicuro-next/platform/monitoring';
import { Store } from '@ngrx/store';
import { combineLatest, from, map, Observable, of, switchMap } from 'rxjs';
import { catchError, shareReplay } from 'rxjs/operators';

@Injectable()
export class TargetService {
  public isMobile$: Observable<boolean> = of(
    this.platform.ANDROID || this.platform.IOS,
  ).pipe(shareReplay({ bufferSize: 1, refCount: true }));

  public isIos$: Observable<boolean> = of(this.platform.IOS).pipe(
    shareReplay({ bufferSize: 1, refCount: true }),
  );
  public isSafari$: Observable<boolean> = of(this.platform.SAFARI).pipe(
    shareReplay({ bufferSize: 1, refCount: true }),
  );

  constructor(
    private platform: Platform,
    private loggerService: LoggerService,
    private store: Store,
  ) {}

  public shareTarget(data: ShareData): Observable<boolean> {
    if (!navigator.share) {
      return of(false);
    }

    return combineLatest([
      this.isMobile$,
      this.store.select(selectDisabledShareBrowserApi),
    ]).pipe(
      switchMap(([isMobile, isDisabledShare]) => {
        if (!isMobile && isDisabledShare) {
          return of(false);
        }

        return from(navigator.share(data)).pipe(
          map(() => true),
          catchError((error) => {
            if (error.name === 'AbortError') {
              return of(true);
            }

            this.loggerService.exception({
              error,
              severity: SeverityLevel.Information,
            });
            return of(false);
          }),
        );
      }),
    );
  }
}
